//import applicationLogo from '../../images/Pictionary_Logo Copy 2-Pictionary_Logo@2x.png';
//import applicationLogo from '../../../images/Pictionary_Logo Copy 2-Pictionary_Logo@2x.png';
import applicationLogo from '../../../images/25wol_logo.svg';
import { getCdnPath } from '../../../utils/helpers';

const Logo = (props) =>{
    const width = props.width?? process.env.REACT_APP_LOGO_WIDTH;
    const padding = props.padding?? process.env.REACT_APP_LOGO_PADDING;

    return (
        <img src={getCdnPath(process.env.REACT_APP_LOGO_URL)} alt="Application Logo" style={{width: width, height: "auto", padding : padding}}/>
    )
}

export default Logo;